// check is journal enabled based on props
export function checkIsJournalEnabled(props) {
    let selectedGroupIdx = -1;
    if (props?.uData && props?.selectedGroup && props?.uData?.clinicGroups?.length) {
        for (let i = 0; i < props?.uData?.clinicGroups?.length; i++) {
            if (props?.uData?.clinicGroups[i]?._id == props?.selectedGroup) {
                selectedGroupIdx = i;
                break;
            }
        }
    }

    const journalCuroflowEnable =
        props?.uData &&
            props?.uData?.clinicGroups &&
            props?.uData?.clinicGroups[selectedGroupIdx] &&
            props?.uData?.clinicGroups[selectedGroupIdx]?.journalCuroflow &&
            props?.uData?.clinicGroups[selectedGroupIdx]?.journalCuroflow?.journalCuroflowApiKey
            ? true
            : false;

    return journalCuroflowEnable;
}

export function checkIsUserActiveOnJournal(props) {
    let selectedGroupIdx = -1;
    if (props?.uData && props?.selectedGroup && props?.uData?.clinicGroups?.length) {
        for (let i = 0; i < props?.uData?.clinicGroups?.length; i++) {
            if (props?.uData?.clinicGroups[i]?._id == props?.selectedGroup) {
                selectedGroupIdx = i;
                break;
            }
        }
    }

    if (props.uData?.journalCuroflow?.[props?.selectedGroup]?.active === true) {
        return true;
    }

    return false;
}

// THIS CLINIC ADMIN CHECKER IS NOT ASSOCIATED WITH JOURNAL!
export function isClinicAdminChecker(props) {
    const num = props.uData && props.uData.permissions && props.uData.permissions.admin && props.uData.permissions.clinicAdmin && props.selectedClinic && props.selectedGroup && props.uData.groupPermissionsUser && props.uData.groupPermissionsUser[props.selectedGroup] &&
        props.uData.groupPermissionsUser[props.selectedGroup][props.selectedClinic] && props.uData.groupPermissionsUser[props.selectedGroup][props.selectedClinic].filter(el => el == props.uData.permissions.admin || el == props.uData.permissions.clinicAdmin).length
    if (Number(num) > 0) {
        return true;
    }
    return false;
}